export default __webpack_public_path__ + "static/logo-0bdc700e0829757ce0f18d0003f30978.png";